import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import type { CorporateApprovalStatus } from '../api/types/corporate';

const CorporateApprovalBanner: React.FC = () => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user?.isCorporate) {
    return null;
  }

  const status = user.corporateApprovalStatus as CorporateApprovalStatus | undefined;

  if (status === 'Pending') {
    return (
      <div className="alert alert-warning m-0 rounded-0 border-0 text-center py-2 small mb-0" role="alert">
        <strong>Kurumsal hesabınız onay bekliyor.</strong>{' '}
        İlan oluşturma, mesajlaşma, reel yükleme ve diğer satıcı işlemleri onaylanana kadar kısıtlıdır.
        Görüntüleme (okuma) işlemlerine devam edebilirsiniz.
      </div>
    );
  }

  if (status === 'Suspended') {
    return (
      <div className="alert alert-danger m-0 rounded-0 border-0 text-center py-2 small mb-0" role="alert">
        <strong>Kurumsal hesabınız askıya alınmıştır.</strong>{' '}
        İlan oluşturma, mesajlaşma, reel yükleme ve diğer satıcı işlemleri geçici olarak devre dışıdır.
        Görüntüleme (okuma) işlemlerine devam edebilirsiniz. Destek için{' '}
        <a href="/destek" className="alert-link">
          destek talebi
        </a>{' '}
        oluşturabilirsiniz.
      </div>
    );
  }

  return null;
};

export default CorporateApprovalBanner;
